import type { DashboardChartType } from '../types';

export interface DashboardChartTypeMeta {
  readonly type: DashboardChartType;
  readonly label: string;
  readonly icon: string;
}

export const DASHBOARD_CHART_TYPE_META: ReadonlyArray<DashboardChartTypeMeta> = [
  { type: 'line', label: 'Line', icon: 'show_chart' },
  { type: 'area', label: 'Area', icon: 'area_chart' },
  { type: 'bar', label: 'Bar', icon: 'bar_chart' },
  { type: 'bar-horizontal', label: 'Horizontal bar', icon: 'view_week' },
  { type: 'stacked-bar', label: 'Stacked bar', icon: 'stacked_bar_chart' },
  { type: 'donut', label: 'Donut', icon: 'donut_large' },
  { type: 'rating-bars', label: 'Rating bars', icon: 'leaderboard' },
  { type: 'source-list', label: 'Source list', icon: 'reorder' },
];

export const DASHBOARD_CHART_TYPE_INDEX: Readonly<Record<DashboardChartType, DashboardChartTypeMeta>> =
  DASHBOARD_CHART_TYPE_META.reduce(
    (acc, meta) => ({ ...acc, [meta.type]: meta }),
    {} as Record<DashboardChartType, DashboardChartTypeMeta>,
  );
